import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core/styles';
import { observer } from "mobx-react";
import { useEffect, useState } from 'react';
import { Box, Grid, Tooltip, Typography, Chip } from '@material-ui/core';
import { AutocompleteField, MultiSelectField, createTextField, Button } from '@roc/ui';
import { templatePlaceHolders } from 'libs/feature-communication/src/communication/utils/constants';
import { useUserStore } from "@roc/feature-app-core";
import { MAX_FILE_SIZE } from 'libs/feature-communication/src/communication/utils/constants';
import { useStore } from 'apps/client-portal-public/src/app/hooks';
import { BaseLeadStore } from 'libs/client-portal-shared/src/app/modules/companyProfile/stores/baseLeadStore/BaseLeadStore';
import RichTextWithAttachments from '../../../utils/richTextWithAttachments';
import { HtmlContainer } from '../../leadDetails/htmlContainer';
import { CadenceStore } from 'libs/client-portal-shared/src/app/modules/companyProfile/stores/cadenceStore/cadenceStore';
import { LEAD_OBJECT_TYPE } from '../../leads/constants/constants';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%'
    },
    contentContainer: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    previewBox: {
      [theme.breakpoints.up('sm')]: {
        width: '100%'
      },
      [theme.breakpoints.up('lg')]: {
        width: '75%',
      },
    },
    divider: {
      position: 'absolute',
      border: '1px solid grey',
      height: '95%',
      [theme.breakpoints.up('lg')]: {
        left: '53%',
      },
      [theme.breakpoints.down('md')]: {
        left: '50%',
      },
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    modalContainer: {
      position: 'relative'
    },
    dueChip: {
      backgroundColor: "#9c27b0",
      color: "white",
      padding: "5px 10px",
      borderRadius: "20px",
    },
    tooltip: {
      fontSize: '1.2rem',
    },
  })
);

// const emailList = [
//   "john.doe@example.com",
//   "jane.smith@example.com",
//   "alex.jones@example.com",
//   "susan.clark@example.com",
//   "michael.brown@example.com",
//   "linda.davis@example.com",
//   "robert.miller@example.com",
//   "patricia.wilson@example.com",
//   "james.moore@example.com",
//   "mary.taylor@example.com"
// ];

export const EmailStepsDue = observer(({ handleClose = () => { }, salesforceLeadStore, type, fromGrid = false, currentStep, cadenceStore, cadence = null }: { handleClose, salesforceLeadStore: BaseLeadStore, type, fromGrid?, currentStep, cadenceStore: CadenceStore, cadence?}) => {
  const { sendEmailsStore } = salesforceLeadStore;
  const { sendBulkEmailFormStore } = sendEmailsStore;
  const { userStore, userStore: { userInformation } } = useUserStore();
  const userEmail = salesforceLeadStore.isSalesForce ? salesforceLeadStore.emailAddress : userInformation.username;
  const [attachments, setAttachments] = useState<File[]>([]);
  const [mockAttachments, setMockAttachments] = useState([]);
  const [sendTo, setSendTo] = useState([]);
  const [emailList, setEmailList] = useState([]);
  const { globalStore } = useStore();

  useEffect(() => {
    fetchData();
    sendEmailsStore.initSentToOptions(type);
    onEditorChange(currentStep)
    setProspects(currentStep);
    setProspectsEmails(currentStep)
    setSendTo(sendEmailsStore.sendToOptions);
  }, []);


  useEffect(() => {
    sendEmailsStore.mockAttachments = mockAttachments;
  }, [mockAttachments]);


  const setProspects = (currentStep) => {
    sendEmailsStore.bulkEmails = [];

    const prospects = currentStep?.prospects ?? [];

    const LEAD_TYPE = LEAD_OBJECT_TYPE.toUpperCase();
    const stepRecordType = (currentStep?.cadenceStepsInfo?.recordType ?? LEAD_OBJECT_TYPE).toUpperCase();

    prospects.forEach((prospect) => {
      const recordType = (prospect?.recordType ?? stepRecordType).toUpperCase();
      const isLead = recordType === LEAD_TYPE;

      const leadId = prospect?.cadenceContactInfo?.leadId;
      const contactId = prospect?.cadenceContactInfo?.contactId;

      const id = isLead ? leadId : contactId;
      if (!id || !prospect?.email) return;

      sendEmailsStore.setBulkEmails(
        {
          email: prospect.email,
          firstName: prospect.firstName,
          lastName: prospect.lastName,
          cadenceUserId: prospect?.cadenceContactInfo?.cadencesContactDataId,
          id,
          type: isLead ? LEAD_OBJECT_TYPE : 'CONTACT',
        },
        prospect
      );
    });
  };

  const setProspectsEmails = (currentStep) => {
    setEmailList(currentStep?.prospects?.map(prospect => prospect.email).filter(Boolean) || []);
  };

  useEffect(() => {
    sendEmailsStore.updatePreview(userEmail, sendEmailsStore.getContentText, userInformation);
    setMockAttachments(sendEmailsStore.mockAttachments);
  }, [
    sendBulkEmailFormStore.form.fields.contentText.value,
    sendEmailsStore.selectedTemplateOption
  ]);

  const onFilesChange = (event): void => {
    const { files } = event.target as HTMLInputElement;
    if (files?.length) {
      addFiles(Array.from(files));
    }
  };

  const addFiles = (newFiles: File[]) => {
    const validFiles = newFiles.filter(
      ({ size }) => size < MAX_FILE_SIZE + 1
    );
    setAttachments(currentFiles => [...currentFiles, ...validFiles]);
  }

  const refreshCadenceDashboard = () => {
    cadenceStore.fetchCadencesDueByBackofficeOriginatorAndCadenceId();
  }

  const fetchData = async () => {
    sendEmailsStore.getTemplateOptions();
    sendEmailsStore.selectedTemplateOption = '';
  };

  function handleSendClick() {
    console.log('Will send emails in blast for people in cadece')
    let sentToAll = true;
    sendEmailsStore.sendToAll = sentToAll;
    if (sentToAll) {
      sendEmailsStore.listId = salesforceLeadStore?.option?.value;
    }
    const fields = sendBulkEmailFormStore.form.fields;
    if (sendTo.length > 0 && fields.subject.value && fields.contentText.value) {
      sendEmailsStore.sendBulkEmail(sentToAll, userEmail, attachments, sendTo, fromGrid, salesforceLeadStore?.gridBusinessUnit, true, handleClose, cadence?.cadenceAssigneeId);
    } else {
      globalStore.notificationStore.showErrorNotification({
        message: 'There is no data to send',
      })
    }
  }

  // const handleSendClickToSelf = () => {
  //   sendEmailsStore.sendToSelf(userEmail);
  //   handleClose();
  // }

  const onEditorChange = (currentStep) => {
    sendBulkEmailFormStore.onFieldChange('contentText', currentStep?.cadenceStepsInfo?.stepContent?.content);
    sendBulkEmailFormStore.onFieldChange('subject', currentStep?.cadenceStepsInfo?.stepContent?.subject);
  }


  // const allOption = { label: "All", value: 'all' };
  // ;


  // const isDisabled = (option) => {
  //   const selectedValues = sendTo.map(opt => opt.value);
  //   if (option.value === 'additional2' && !selectedValues.includes('additional1')) return true;
  //   if (option.value === 'additional3' && !selectedValues.includes('additional2')) return true;
  //   if (option.value === 'additional4' && !selectedValues.includes('additional3')) return true;
  //   if (option.value === 'additional5' && !selectedValues.includes('additional4')) return true;
  //   return false;
  // };


  // const handleSendToChange = (_, sendTo) => {
  //   if (sendTo.some(owner => owner.value === allOption.value)) {
  //     sendTo = [allOption];
  //   }
  //   setSendTo(sendTo);
  //   sendBulkEmailFormStore.onFieldChange('sendTo', sendTo.map(o => o.value))
  // };

  const classes = useStyles();
  return (
    <Grid container spacing={2} className={classes.modalContainer}>
      {!!sendEmailsStore.previewHtml && (
        <>
          <Grid item xs={12} className={classes.container}>
            <Box className={classes.previewBox}>
              <Box>
                <Box>
                  <Typography variant="h6">From: {userEmail}</Typography>
                </Box>
                <Box>
                  <Typography variant="h6">
                    To:
                    <Tooltip
                      title={emailList.sort().join(', ')}
                      classes={{ tooltip: classes.tooltip }}
                    >
                      <Chip
                        className={classes.dueChip}
                        label={`${emailList.length} emails:`}
                        size="small"
                      />
                    </Tooltip>
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="h6">Subject: {sendEmailsStore.sendBulkEmailFormStore.form.fields.subject.value}</Typography>
                </Box>
              </Box>
              <Box>
                <HtmlContainer html={sendEmailsStore.previewHtml} />
              </Box>
            </Box>
          </Grid>
        </>
      )}
      <Grid item xs={12}>
        <Box display="flex" justifyContent="flex-end">
          <Button
            variant="contained"
            disabled={currentStep?.prospects?.length === 0}
            color="primary"
            onClick={handleSendClick}
            style={{ width: '200px', margin: '0 5px' }}
            testId="next"
          >Send</Button>
        </Box>
      </Grid>
    </Grid>
  )
});
